/**
 * Verschlüsselte Einträge, die dieses Gerät noch nicht öffnen kann (E21) —
 * einmal je Reiter, mit dem Weg dorthin, statt still zu fehlen.
 *
 * - Konto verschlüsselt, Gerät nicht entsperrt: entsperren.
 * - Entsperrt, aber der Haushaltsschlüssel fehlt noch: ein anderes Gerät im
 *   Haushalt reicht ihn nach, sobald dort die App offen ist.
 * - Kind (kein Kontoschlüssel): ein Elterngerät reicht ihn nach.
 */

import { useLiveQuery } from 'dexie-react-hooks';
import { useTranslation } from 'react-i18next';
import { db } from '../db/local.js';
import { readAccountKey } from '../crypto/e2e.js';
import { useIsChild } from '../hooks/useModules.js';
import { UnlockEncryption } from './EncryptionSetting.js';

export function SealedNotice({ id }: { id: string }): React.JSX.Element | null {
  const { t } = useTranslation();
  const child = useIsChild();
  const held = useLiveQuery(() => db.sealed_rows.count(), [], 0);
  const unlocked = useLiveQuery(async () => Boolean(await readAccountKey(db)), [], false);
  if (held === 0) return null;
  return (
    <section aria-labelledby={id} className="kw-tile flex flex-col gap-2">
      <h2 id={id} className="kw-kicker">
        {t('e2e.sealedHeading', { count: held })}
      </h2>
      {child ? (
        <p className="text-sm text-ink-muted">{t('e2e.waitingParent')}</p>
      ) : unlocked ? (
        <p className="text-sm text-ink-muted">{t('e2e.waitingHousehold')}</p>
      ) : (
        <UnlockEncryption />
      )}
    </section>
  );
}
